export default {
  REPORT_AN_INCIDENT: 'Report an incident',
  WHATS_GOING_ON: 'Whats going on?',
  WHATS_GOING_ON_DESC: `Please describe what's going on including steps to reproduce the issue. The more specific you are, the easier it's going to be for your colleagues to locate the issue and resolve the incident.`
}
